import { TableColumn } from "../pages/ListReceipt";

export const pendingReceiptColumns: TableColumn[] = [
  { key: "image", header: "Image" },
  { key: "amount", header: "Amount" },
  { key: "loyaltyCardNo", header: "Loyalty Card No." },
  { key: "createdAt", header: "Created At" },
  { key: "merchantId", header: "Merchant ID" },
  { key: "evoucherAmount", header: "Evoucher Amount" },
  { key: "evoucherCode", header: "Evoucher Code" },
  { key: "physicalVoucherAmount", header: "Physical Voucher Amount" },
  { key: "physicalVoucherCode", header: "Physical Voucher Code" },
  // { key: "points", header: "Points" },
];

export const pendingReceiptMetaData = {
  image: {
    isImage: true,
    linkTo: "",
  },
  amount: {
    isImage: false,
    linkTo: "",
  },
  loyaltyCardNo: {
    isImage: false,
    linkTo: "",
  },
  createdAt: {
    isImage: false,
    linkTo: "",
  },
  merchantId: {
    isImage: false,
    linkTo: "",
  },
  evoucherAmount: {
    isImage: false,
    linkTo: "",
  },
  evoucherCode: {
    isImage: false,
    linkTo: "",
  },
  physicalVoucherAmount: {
    isImage: false,
    linkTo: "",
  },
  physicalVoucherCode: {
    isImage: false,
    linkTo: "",
  },
  // points: {
  //   isImage: false,
  //   linkTo: "",
  // },
};
